export default function (src = window) {
  // never use the agent banner within baemax admin
  if (src.clientOptions && src.clientOptions.hasOwnProperty('user')) {
    return false
  }

  if (/\bagent=true\b/.test(src.location.search)) {
    return true
  }

  // hook to turn off the agent flag
  if (/\bagent=false\b/.test(src.location.search)) {
    return false
  }

  try {
    const cacheStr = src.localStorage.getItem('mylo-query-params')
    const cache = src.JSON.parse(cacheStr)
    return !!cache && cache.hasOwnProperty('agent') && cache.agent === 'true'
  } catch (error) {
    return false
  }
}
